import {
  ProductInformationContainer,
  ProductInformationDescription,
  ProductInformationTitle,
} from 'features/menu/components/product-detail/product-information/styled';

import { t } from 'state/intl/translations';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

interface IProductInformationProps {
  selectedProduct: ILocalizedMenuEntry;
}
export const ProductInformation: React.FC<IProductInformationProps> = ({ selectedProduct }) => {
  const title = t('productInformation');
  return (
    <ProductInformationContainer>
      <ProductInformationTitle accessibilityRole="header" accessibilityLevel={3}>
        {title}
      </ProductInformationTitle>
      {/* TODO: Should this be a sanity block content?  */}
      <ProductInformationDescription>
        {selectedProduct.description?.locale}
      </ProductInformationDescription>
    </ProductInformationContainer>
  );
};
